import { Vue } from 'vue-property-decorator'
import { NotificationListType, NotificationEditType } from '@/models/notificationModel'
import { PaginationStatus } from '@/models/paginationModel'
import { ApiResponseNotificationList, ApiResponseNotificationEditData } from '@/models/apiResponses/notifications'

export class NotificationManagementUtils {
  /**
   * APIレスポンスをお知らせ一覧情報に変換する
   * @param apiResponse お知らせ一覧検索APIレスポンス
   * @returns お知らせ一覧情報
   */
  public static formatNotificationDatas(apiResponse: ApiResponseNotificationList): NotificationListType[] {
    if (!apiResponse) return []

    return apiResponse.responses
  }

  /**
   * APIレスポンスからページネーションの状態を取得
   * @param apiResponse お知らせ一覧検索APIレスポンス
   * @returns ページネーション情報
   */
  public static getPagenationStatus(apiResponse: ApiResponseNotificationList): PaginationStatus | null {
    if (!apiResponse) return null

    return apiResponse.pagination
  }

  /**
   * APIレスポンスからお知らせ編集情報を生成する
   * @param apiResponse お知らせ取得APIレスポンス
   * @returns お知らせ編集情報
   */
  public static async buildNotificationEditData(
    apiResponse?: ApiResponseNotificationEditData
  ): Promise<NotificationEditType> {
    if (!apiResponse) {
      return {
        title: '',
        startDate: null,
        endDate: null,
        message: '',
      }
    }
    // 本文はbase64で渡されるため、デコードに成功した場合はその値を使用する
    const message = await Vue.prototype.$compress.base64ToString(apiResponse.message)
    return {
      id: apiResponse.id,
      title: apiResponse.title,
      startDate: apiResponse.startDate,
      endDate: apiResponse.endDate,
      message: message !== null ? message : apiResponse.message,
    }
  }
}
